export default function safeProps(props) {
  const newProps = { ...props };
  for (let k in props) {
    if (props[k] === true) {
      newProps[k] = 'true';
    } else if (props[k] === false) {
      newProps[k] = 'false';
    }
  }
  return newProps;
}

export function strippedProps(props) {
  const {
    headerBlock,
    xLarge,
    maxWidth,
    pointer,
    grayDark,
    grayDarkMedium,
    primary,
    primaryDark,
    primaryLight,
    coolGray,
    banner,
    header,
    large,
    bold,
    text,
    subtext,
    white,
    noclip,
    gray,
    clickable,
    grayMedium,
    small,
    letterSpacing,
    italic,
    inline,
    xsmall,
    noPadding,
    noMin,
    pn,
    t_title,
    bannersmall,
    lineSpacing,
    hoverColor,
    link,
    backgroundColor,
    roundedRight,
    secondary,
    action,
    ...rest
  } = props;
  return rest;
}



// WEBPACK FOOTER //
// ./src/components_new/safeProps.js